import { Card } from '@yleisradio/areena-types';
import { CardWithPointer, LoggedInSubAccount } from './types';

export function isSubAccount(obj: unknown): obj is LoggedInSubAccount {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    'isSubAccount' in obj &&
    obj.isSubAccount === true
  );
}

export function isCardWithPointer(
  card: Card | undefined
): card is CardWithPointer {
  return card?.pointer !== undefined;
}
